module.exports = "/images/blister-1.png";